var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConversion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.90217 0.000709153C4.55809 0.020478 3.20586 0.449746 2.10328 1.31864C0.767355 2.3711 0.00105518 3.91401 3.62256e-05 5.53601C3.62256e-05 5.69792 -0.00200167 5.86266 0.0244926 6.04058L0.048949 6.25898H1.62231L1.59785 5.98787C1.33393 3.73798 3.09173 1.71966 5.52718 1.47679C7.02411 1.32711 8.49965 1.89476 9.44835 2.97546L8.24183 4.09005H11.7391V0.859245L10.5652 1.94371C9.35562 0.633314 7.63042 -0.0247081 5.90217 0.000709153ZM10.3777 5.7361L10.4021 6.00722C10.6661 8.25711 8.90827 10.2754 6.47282 10.5183C4.97589 10.668 3.50036 10.1003 2.55165 9.01963L3.75817 7.90504H0.260904V11.1358L1.43481 10.0514C3.58493 12.3803 7.37567 12.6628 9.89672 10.6765C11.2326 9.62399 11.9989 8.08107 12 6.45908C12 6.29717 12.002 6.13242 11.9755 5.9545L11.9511 5.7361H10.3777Z",
    fill: "#A4A4FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConversion);
export default __webpack_public_path__ + "static/media/conversion.d995e2210c812dfaa1cf8926ca62c3ec.svg";
export { ForwardRef as ReactComponent };